import { Pencil } from 'lucide-react'
import Tooltip from './Tooltip'

const EditButton = ({ handleClick, isDisabled }: { handleClick: () => void; isDisabled?: boolean }) => {
    return (
        <div className='flex'>
            <Tooltip label={isDisabled ? 'Alteração desabilitada' : 'Alterar cadastro'} placement='bottom'>
                <button
                    onClick={handleClick}
                    disabled={isDisabled}
                    className='bg-brand-100 hover:bg-brand-200 text-brand-600 dark:bg-brand-500/[0.12] dark:hover:bg-brand-500/[0.23] dark:text-brand-500 py-2 px-3 flex items-center gap-1 rounded-full disabled:opacity-50 disabled:cursor-not-allowed'
                >
                    <Pencil size={14} />
                    <p>Alterar</p>
                </button>
            </Tooltip>
        </div>
    )
}

export default EditButton
